import React, { useEffect, useState } from "react";
import { fetchOfferList } from "../../../Redux/OfferSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import KpiModal from "../../../components/KpiMadal";

const Offer = ()=> {
    const [isModal, setIsModal] =  useState(false)
    const [kpi, setKpi] = useState()
    const offerList = useSelector((state)=> state.offer.list)
    const admin = JSON.parse(localStorage.getItem('offerAdmin'))
    const dispatch = useDispatch();

    const handleKpiModal = (item)=> {
        setIsModal(true)
        setKpi(item.KPI);
    }
    useEffect(()=> {
        dispatch(fetchOfferList());
    },[])

    return (
        <>
        <div className="bg-gray-200 py-4">
        <div class="px-4 sm:px-4">
        <div class="pt-20 pb-10">
            <div class="flex sm:flex-row flex-col pb-2">
                <div class="flex flex-row mb-1 sm:mb-0">
                    <div class="relative">
                        <select
                            class="appearance-none h-full rounded-l border block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                            <option>5</option>
                            <option>10</option>
                            <option>20</option>
                        </select>
                        <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                        </div>
                    </div>
                    <div class="relative">
                        <select
                            class="appearance-none h-full rounded-r border-t sm:rounded-r-none sm:border-r-0 border-r border-b block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:border-l focus:border-r focus:bg-white focus:border-gray-500">
                            <option>All</option>
                            <option>Active</option>
                            <option>Inactive</option>
                        </select>
                        <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="block relative">
                    <span class="h-full absolute inset-y-0 left-0 flex items-center pl-2">
                        <svg viewBox="0 0 24 24" class="h-4 w-4 fill-current text-gray-500">
                            <path
                                d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z">
                            </path>
                        </svg>
                    </span>
                    <input placeholder="Search"
                        class="appearance-none rounded-r rounded-l sm:rounded-l-none border border-gray-400 border-b block pl-8 pr-6 py-2 w-full bg-white text-sm placeholder-gray-400 text-gray-700 focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none" />
                </div>
            </div>
            <div class="overflow-x-auto">
                <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
                    <table class="min-w-full leading-normal">
                        <thead>
                            <tr>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    Offer Id
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    Offer Name
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    Status
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                   model
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                   Payout
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    GEO
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    OS
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    VTA
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    mmp
                                </th>
                                
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    Mmp Available
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                    Rejection Criteria
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                   KPI
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                   Preview Link
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-sky-900 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider text-white">
                                   Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                          {offerList.map((item)=> <tr>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                            <p class="text-gray-900 whitespace-no-wrap">{item._id}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                            <p class="text-gray-900 whitespace-no-wrap">
                                                <Link to={`../offerdetails/${item._id}`}>{item.campaign_name}</Link>
                                            </p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <span
                                        class="relative inline-block px-3 py-1 text-white leading-tight">
                                            <span aria-hidden
                                            className={item.status === 'ACTIVE'? 'absolute inset-0 rounded-full statusBtn' : 'absolute inset-0 rounded-full statusInactive'}></span>
                                        <span class="relative">{item.status}</span>
                                    </span>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.offerModel}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.Payout}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.Geo}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.os}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.VTA}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.mmp}</p>
                                </td>
                              
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.MmpAvailable}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap">{item.RejectionCriteria}</p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap"><button className="text-blue-400" onClick={()=> handleKpiModal(item)}>View</button></p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap"><Link to={item.preview_link} target="_blank">{item.preview_link}</Link></p>
                                </td>
                                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-left">
                                    <p class="text-gray-900 whitespace-no-wrap flex justify-between gap-2"><button className="py-1 px-2 border rounded-lg bg-green-200">Edit</button> <button className="py-1 px-2 border rounded-lg bg-red-300">Delete</button></p>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
            <KpiModal isModal={isModal} setIsModal={setIsModal} kpi={kpi}/>
        </div>
    </div>
        </div>
        </>
    )
}
export default Offer